/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FollowButton_favoritesConnection = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
        } | null;
    } | null> | null;
    readonly " $refType": "FollowButton_favoritesConnection";
};
export type FollowButton_favoritesConnection$data = FollowButton_favoritesConnection;
export type FollowButton_favoritesConnection$key = {
    readonly " $data"?: FollowButton_favoritesConnection$data;
    readonly " $fragmentRefs": FragmentRefs<"FollowButton_favoritesConnection">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FollowButton_favoritesConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "favoritesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Favorite",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "favoritesConnection",
  "abstractKey": null
};
(node as any).hash = 'd5daf1a913559ba64d69d9e096c60c23';
export default node;
